/**
 * PII tier registry and file-access split (C18).
 *
 * Authority: docs/design/security-privacy.md §1 (tiers) and §3.2 (PUBLIC vs
 * PRIVATE file categories). New FileCategory members must be registered in
 * exactly one of the two lists below — a test enforces this.
 */
import { FileCategory } from '../types/upload.js';
/** Sensitivity tiers (visibility matrix in security-privacy.md §2). */
export const PII_TIER = {
    L1: 'L1', // identity credentials: idNo, ID-card images, insurance files, passwordHash
    L2: 'L2', // contact & location: phone, email, address, wechat ids
    L3: 'L3', // display-grade: names, photo, school, certNo
};
/** Anonymous bucket reads allowed for these prefixes only. */
export const PUBLIC_FILE_CATEGORIES = [
    FileCategory.CERTIFICATE,
    FileCategory.JUDGE_CERTIFICATE,
    FileCategory.SPONSOR_LOGO,
    FileCategory.CAROUSEL_IMAGE,
    FileCategory.SYSTEM_LOGO,
    FileCategory.RESOURCE,
    FileCategory.CERTIFICATE_FONT,
];
/** No anonymous GET — API responses must hand out presigned URLs. */
export const PRIVATE_FILE_CATEGORIES = [
    FileCategory.DOCUMENT,
    FileCategory.INSURANCE,
    FileCategory.PROFILE_PHOTO,
    FileCategory.SUBMISSION_FILE,
    FileCategory.CONFIRMATION_PHOTO,
];
export function isPrivateFileCategory(category) {
    return PRIVATE_FILE_CATEGORIES.includes(category);
}
/** Recovers the category from a storage key like `document/<uuid>-a.jpg`. */
export function fileCategoryFromStorageKey(key) {
    const first = key.split('/')[0];
    if (!first)
        return undefined;
    return Object.values(FileCategory).includes(first)
        ? first
        : undefined;
}
//# sourceMappingURL=pii.js.map